module.exports = __webpack_public_path__ + "static/img/share.c0d7531.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/btn/share.png
// module id = Vw4H
// module chunks = 1